import { createSlice } from "@reduxjs/toolkit"

export interface ServiceCounterState {
    count: number
}

const initialState: ServiceCounterState = {
    count: 0
}

export const serviceCounterSlice = createSlice({
    name: "serviceCount",
    initialState,
    reducers: {
        incrementServiceCounter: (state) => {
            state.count++
        },
        decrementServiceCounter: (state) => {
            state.count--
        }
    }
})

export const serviceCountActions = serviceCounterSlice.actions
export default serviceCounterSlice.reducer